(function() {
  'use strict';
  
  if (window.VariantRestrictionManager) return; // Already loaded

  class VariantRestrictionManager {
    constructor() {
      this.STORAGE_KEY = 'variantRestrictions';
      this.restrictionRules = null; // Cache rules
      this.init();
    }

    init() {
      this.loadRestrictionRules(); // Load once at start
      this.syncCart();
      this.setupEventListeners();
      this.checkAddToCartButton();
    }

    loadRestrictionRules() {
      try {
        const input = document.querySelector('.variant-restrictions-data');
        if (input && input.value) {
          this.restrictionRules = JSON.parse(input.value);
          console.log('Loaded rules from input:', this.restrictionRules);
          return;
        }
        
        const productForm = document.querySelector('product-form');
        if (productForm) {
          const data = productForm.getAttribute('data-variant-restrictions');
          if (data) {
            this.restrictionRules = JSON.parse(data);
            console.log('Loaded rules from data attribute:', this.restrictionRules);
            return;
          }
        }
        
        this.restrictionRules = {};
        console.warn('No restriction rules found');
      } catch (error) {
        console.error('Error loading restriction rules:', error);
        this.restrictionRules = {};
      }
    }

    async syncCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const variantIds = cart.items.map(item => item.variant_id.toString());
        sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(variantIds));
        console.log('Cart synced:', variantIds);
        this.checkAddToCartButton();
      } catch (error) {
        console.error('Error syncing cart:', error);
      }
    }

    setupEventListeners() {
      // Listen for variant changes on the hidden input
      const variantInput = document.querySelector('input[name="id"].product-variant-id');
      if (variantInput) {
        // Use MutationObserver to detect value changes
        const observer = new MutationObserver(() => {
          this.checkAddToCartButton();
        });
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        
        // Also listen for direct changes
        variantInput.addEventListener('change', () => {
          this.checkAddToCartButton();
        });
      }

      // Listen for variant selector changes
      const variantSelects = document.querySelector('variant-selects');
      if (variantSelects) {
        variantSelects.addEventListener('change', () => {
          this.checkAddToCartButton();
        });
      }

      // Sync cart every 2 seconds (for cart updates in other tabs)
      setInterval(() => this.syncCart(), 2000);

      // Sync when page becomes visible
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          this.syncCart();
        }
      });
    }

    getRestrictionRules() {
      return this.restrictionRules || {};
    }

    getCurrentVariantId() {
      const variantInput = document.querySelector('input[name="id"].product-variant-id');
      return variantInput ? variantInput.value : null;
    }

    shouldRestrictVariant(variantId, cartVariants) {
      const rules = this.getRestrictionRules();
      const blockedBy = rules[variantId];
      
      if (!blockedBy || !Array.isArray(blockedBy)) return false;
      
      return cartVariants.some(cartVariantId => blockedBy.includes(cartVariantId));
    }

    checkAddToCartButton() {
      const currentVariantId = this.getCurrentVariantId();
      if (!currentVariantId) return;

      const cartVariants = JSON.parse(sessionStorage.getItem(this.STORAGE_KEY) || '[]');
      const shouldRestrict = this.shouldRestrictVariant(currentVariantId, cartVariants);
      
      console.log('Checking variant:', currentVariantId, 'Restrict:', shouldRestrict);
      
      const addToCartButtons = document.querySelectorAll('button[name="add"], button[type="submit"][name="add"]');
      const quantityInputs = document.querySelectorAll('input[name="quantity"], quantity-input input');
      
      addToCartButtons.forEach(button => {
        if (shouldRestrict) {
          button.disabled = true;
          const buttonText = button.querySelector('span');
          if (buttonText && !buttonText.dataset.originalText) {
            buttonText.dataset.originalText = buttonText.textContent;
            buttonText.textContent = 'Not available with other items';
          }
        } else {
          button.disabled = false;
          const buttonText = button.querySelector('span');
          if (buttonText && buttonText.dataset.originalText) {
            buttonText.textContent = buttonText.dataset.originalText;
            delete buttonText.dataset.originalText;
          }
        }
      });

      // Also disable quantity inputs
      quantityInputs.forEach(input => {
        if (shouldRestrict) {
          input.disabled = true;
          input.value = 0;
        } else {
          input.disabled = false;
          if (input.value === '0') {
            input.value = 1;
          }
        }
      });
    }
  }

  window.VariantRestrictionManager = VariantRestrictionManager;

  // Initialize
  const initManager = () => {
    if (!window.variantRestrictionManagerInstance) {
      window.variantRestrictionManagerInstance = new VariantRestrictionManager();
      console.log('VariantRestrictionManager initialized');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initManager);
  } else {
    initManager();
  }
})();
